import { gql } from "@apollo/client";

// nationality_id-> الجنسية
//national_id -> رقم الهوية
// national_id_type->  بطاقة الهوية,جواز سفر,رقم الاقامة  
export const CREATE_REGISTERATION_FORM=gql`
mutation CreateRegisterForm($input: RegisterFormInput!) {
    createRegisterForm(input: $input){
    success
    message
    user {
      id
      fullname
    }
    form {
      id
      user_id{
        id
      }
      status
    }
    registration_Fees_Value
    registration_Fees_Id
  }
}
`;

export const GET_REGISTERATION_FORM_BY_USER_ID=gql`
query GetRegisterFormByUserId($user_id:ID!) {
    getRegisterFormByUserId(user_id: $user_id) {
        id
        serial
        first_name
        second_name
        third_name
        fourth_name
        birthdate
        gender
        is_paid
        paid_document_file
        high_school_certificate_file
        is_clearance
        academic_record
        address
        status
        mobile
        home_tel
        email
        is_inside_yemen
        national_id_type
        national_id
        education_year
        study_place
        high_school_student_number
        general_grade
        gpa
        createdAt
        updatedAt
        faculty_department_id {
            id
            title_ar
            title_en
            status
            createdAt
            updatedAt
        }
        faculty_id {
            id
            title_ar
            title_en
            status
            required_dep
            study_years_count
            createdAt
            updatedAt
        }
        country_id {
            id
            name_ar
            name_en
            createdAt
            updatedAt
        }
        city_id {
            id
            name_ar
            name_en
            country_id
            createdAt
            updatedAt
        }
        academyTerm_id {
            id
            title_ar
            title_en
            status
            study_year
            current_year
            term_number
            min_study_hours
            max_study_hours
            materials_array {
                id
                title_ar
                title_en
                status
                fullmark_degree
                success_degree
                material_hours
                createdAt
                updatedAt
            }
            faculty_department_id {
                id
                title_ar
                title_en
                status
                createdAt
                updatedAt
            }
        }
        nationality_id {
            id
            name_ar
            name_en
            flag
            createdAt
            updatedAt
        }
        user_id {
            id
            username
            fullname
            email
            mobile
            role
            status
            profile_image
            qid_number
            createdAt
            updatedAt
        }
    }
}
`;

export const GET_REGISTER_FORM_BY_ID = gql`
query GetRegisterFormById($id: ID!) {
    getRegisterFormById(id: $id) {
        id
        serial
        first_name
        second_name
        third_name
        fourth_name
        birthdate
        gender
        is_paid
        paid_document_file
        high_school_certificate_file
        is_clearance
        academic_record
        address
        status
        reviewed_at
        mobile
        home_tel
        email
        is_inside_yemen
        national_id_type
        national_id
        education_year
        study_place
        high_school_student_number
        general_grade
        gpa
        createdAt
        updatedAt

        user_id {
            id
            serial
            username
            fullname
            email
            mobile
            role
            status
            profile_image
            qid_number
            is_inside_yemen
            createdAt
            updatedAt
        }
        nationality_id {
            id
            serial
            name_ar
            name_en
            flag
            status
            createdAt
            updatedAt
        }
        faculty_id {
            id
            serial
            title_ar
            title_en
            status
            required_dep
            study_years_count
            createdAt
            updatedAt
        }
        faculty_department_id {
            id
            serial
            title_ar
            title_en
            status
            createdAt
            updatedAt
        }
        country_id {
            id
            serial
            name_ar
            name_en
            status
            is_local
            createdAt
            updatedAt
        }
        city_id {
            id
            serial
            name_ar
            name_en
            country_id
            status
            createdAt
            updatedAt
        }
        academyTerm_id {
            id
            serial
            title_ar
            title_en
            status
            study_year
            current_year
            term_number
            min_study_hours
            max_study_hours
        }
    }
}
`;

export const GET_ALL_FILTERED_REGISTER_FORMS = gql`
query FilteredPagedRegisterForms($search: String, $status: String, $faculty_id: ID, $faculty_department_id: ID, $page: Int, $limit: Int) {
    filteredPagedRegisterForms(search: $search, status: $status, faculty_id: $faculty_id, faculty_department_id: $faculty_department_id, page: $page, limit: $limit) {
        total
        registerForms {
            id
            serial
            first_name
            second_name
            third_name
            fourth_name
            birthdate
            gender
            is_paid
            paid_document_file
            high_school_certificate_file
            is_clearance
            academic_record
            address
            status
            reviewed_at
            mobile
            home_tel
            email
            is_inside_yemen
            national_id_type
            national_id
            education_year
            study_place
            high_school_student_number
            general_grade
            gpa
            createdAt
            updatedAt
            faculty_id {
                id
                serial
                title_ar
                title_en
                status
                required_dep
                study_years_count
                createdAt
                updatedAt
            }
            faculty_department_id {
                id
                serial
                title_ar
                title_en
                status
                createdAt
                updatedAt
                faculty_id {
                    id
                    serial
                    title_ar
                    title_en
                    status
                    required_dep
                    study_years_count
                    createdAt
                    updatedAt
                }
            }
        }
    }
}
`;
export const APPROVE_REGISTER_FORM = gql`
mutation ApproveRegisterForm($id: ID!) {
    approveRegisterForm(id: $id) {
        success
        message
        registration_Fees_Value
        registration_Fees_Id
    }
}
`;

export const REJECT_REGISTER_FORM = gql`
mutation RejectRegisterForm($id: ID!) {
    rejectRegisterForm(id: $id) {
        success
        message
        registration_Fees_Value
        registration_Fees_Id
    }
}
`;

export const UPDATE_REGISTER_FORM = gql`
mutation UpdateRegisterForm($id: ID!, $input: RegisterFormInput!) {
    updateRegisterForm(id: $id, input: $input) {
        id
    }
}
`;

export const DELETE_REGISTER_FORM = gql`
mutation DeleteRegisterForm($id: ID!) {
    deleteRegisterForm(id: $id)
}
`;
